module.exports = __webpack_public_path__ + "media/images/application/default/default-podcast-007dba621a9169d0954e9fa30bb3d256.jpg";